export const MATERIAL_COSTS_USD_PER_LB: Record<string, number> = {
  "LDPE-8melt": 0.55,
  Polypropylene: 0.94,
  LLDPE: 1.42,
  Regrind: 0,
};
